import $ from "jquery";

const registerPopup = () => {
  const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  };

  const setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  };

  const init = () => {
    $(window).on("scroll", function () {
      if (!getCookie("popupShown")) {
        if ($(window).scrollTop() > $(window).height()) {
          showPopup();
          setCookie("popupShown", true, 1);
        }
      }
    });
    bindCloseButton();
  };

  const showPopup = () => {
    $("#popup-overl").removeClass("hiddens");
    $("#popup-overl").addClass("shows");
  };

  const bindCloseButton = () => {
    $("#pr-close-btn").on("click", function () {
      hidePopup();
    });
  };

  const hidePopup = () => {
    $("#popup-overl").removeClass("shows");
    $("#popup-overl").addClass("hiddens");
  };

  init();
};

try {
  registerPopup();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
